import Api from "./base/api-base";

export default class SubcontractorApi {
  // 外注作業者マスタ一覧取得
  list() {
    return Api.get({
      endpoint: Api.endpoint.subcontractor,
    });
  }

  // 外注作業者マスタ登録
  store (params) {
    return Api.post({
      endpoint: Api.endpoint.subcontractor,
      params: params
    });
  }

  // 外注作業者マスタ情報取得
  info (id) {
    return Api.get({
      endpoint: Api.endpoint.subcontractor,
      id: id,
    });
  }

  // 外注作業者マスタ更新
  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.subcontractor,
      id: id,
      params: params
    });
  }

  // 外注作業者マスタ削除
  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.subcontractor,
      id: id,
    });
  }
}
